import { FileTemporalityUpload } from "../../Components/FileDropzone/FileFolder";

export class FileToUpload {
  protected constructor(protected file: FileTemporalityUpload, protected id: string) {}

  static identifiedBy(file: FileTemporalityUpload, id: string) {
    return new this(file, id);
  }

  getFile(): FileTemporalityUpload {
    return this.file;
  }

  getSize(): number {
    return this.file.size;
  }

  getName(): string {
    return this.file.name;
  }

  getType(): string {
    return this.file.type;
  }

  getId(): string {
    return this.id;
  }

  getExercise() {
    return this.file.exercise
  }

  getPeriod() {
    return this.file.period
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isFor(file: FileTemporalityUpload | undefined): boolean {
    return !!file && this.file === file;
  }
}
